<template>
	<v-dialog v-model="visible" max-width="300">
	
		<v-card>
			<v-alert class="mb-0 rounded-b-0" type="error" v-if="errormsg.length !== 0">
				{{ errormsg }}
			</v-alert>
			<v-card-title>Shared with</v-card-title>
			<v-card-text>
				<div
					:key="user.id" 
					v-for="user in acl"
					class="mb-1"
				>
					<v-chip 
						v-if="user.adbid || user.name !== 'System administrator'"
						color="grey-lighten-3"
						close pill
						close-icon="mdi-minus"
						@click="del_share(user.usid)"
						@click:close="del_share(user.usid)"
					>
						<v-user-avatar
							v-if="user.usid > 0"
							color="#192a3e"
							:code="user.name"
							:image="user.adbid ? `/api/addressbook/${user.adbid}/image.png`: ''"
							left
						/>
						<span>{{ user.name }}</span>
					</v-chip>
				</div>
			</v-card-text>
			<v-card-title>Share...</v-card-title>
			<v-card-text>
				<div
					:key="user.id" 
					v-for="user in unselected_users"
					class="mb-1"
				>
					<v-chip 
						v-if="user.adbid || user.name !== 'System administrator'"
						color="grey-lighten-3"
						close pill
						close-icon="mdi-plus"
						@click="add_share(user.id)"
						@click:close="add_share(user.id)"
					>
						<v-user-avatar
							v-if="user.id > 0"
							color="#192a3e"
							:code="user.name"
							:image="user.adbid ? `/api/addressbook/${user.adbid}/image.png`: ''"
							left
						/>
						<span>{{ user.name }}</span>
					</v-chip>
				</div>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		worklist: {
			type: Object,
			default: null
		},
	},
	data() {
		return {
			visible: false,
			loading: false,
			changed: false,
			acl: [],
			users: [],
			errormsg: '',
		}
	},
	created() {
		this.load_users();
	},
	computed: {
		unselected_users() {
			let unselected = [];
			let i;

			for (i = 0; i < this.users.length; i++) {
				if (!this.in_acl(this.users[i].id)) {
					unselected.push(this.users[i])
				}
			}

			return unselected;
		}
	},
	methods: {
		load_users() {
			let self = this;
			this.loading = true;

			axios
				.get("/api/users", { }, {
					"Authorization": "Bearer " + self.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					// Don't ask me why it does work here... 
					let json = val.data;

					if (json.status == "OK") {
						// close dialog
						this.visible = false

						// let the world know
						this.users = json.data;
					} else {
						// self.errormsg = json.reason;
					}
				})
				.catch((e) => {
					console.log(e);
					// self.errormsg = e.message;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		in_acl(usid) {
			if (usid == this.worklist.owner.id) {
				// the owner always has access
				return true;
			};

			if (this.acl == null) {
				return false;
			};

			let i;
			for (i = 0; i < this.acl.length; i++) {
				if (this.acl[i].usid == usid) {
					return true;
				}
			}

			return false;
		},
		add_share(usid) {
			this.errormsg = '';

			axios
				.put("/api/worklists/" + this.worklist.id + "/shared/" + usid, {
					enabled: true
				}, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((d) => {
					// Don't ask me why it does work here... 
					const {status, data, reason} = d.data;

					if (status == "OK") {
						// copy acl
						this.acl = data;

						// let the world know
						this.$emit('changed_share', this.acl);
					} else {
						this.errormsg = reason;
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
		del_share(usid) {
			this.errormsg = '';
			axios
				.put("/api/worklists/" + this.worklist.id + "/shared/" + usid, {
					enabled: false
				}, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((d) => {
					// Don't ask me why it does work here... 
					const {status, data, reason} = d.data;

					if (status == "OK") {
						// copy acl
						this.acl = data;

						// let the world know
						this.$emit('changed_share', this.acl);
					} else {
						this.errormsg = reason;
					}
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
		open(acl) {
			this.acl = acl;
			this.changed = false;

			this.visible = true;
		},
		close() {
			this.visible = false;
		}
	}
}
</script>
